import { request } from '@/services/api/requests';
import { useQuery } from '@tanstack/react-query';

export const useUserInfo = () => {
  return useQuery({
    queryKey: ['user-info'],
    queryFn: () => request.get('/auth/current-user/'),
    select: (data) => data.data,
    staleTime: Infinity,
  });
};
